import QuoteInsights from './QuoteInsights';

export default QuoteInsights;
